import {
  createStore,
  createEffect,
} from "effector";
import { getCustomUserAgent } from "../../../common/customUserAgent";
import { empty } from "../../../common/functions";
import IconDemAttachDoc from "../../../common/assets/icons/attachDoc.png";
import IconDemAttachPdf from "../../../common/assets/icons/attachPdf.png";
import { getUuidAndSession } from "../../../common/localStorage";

export interface IDemFile {
  id: number;
  mime: string;
  name: string;
  size: number;
  url: string;
  base64?: string;
}

export interface IQueryDemFiles {
  demandId: number;
}

export interface IQueryDemFilesResult {
  loaded: boolean;
  fail: boolean;
  failMsg: string;
  files: IDemFile[];
}

export const $demandFiles = createStore<IQueryDemFilesResult>({
  loaded: false,
  fail: false,
  failMsg: "",
  files: [],
});

export const queryDemFiles = createEffect<IQueryDemFiles, any>();

$demandFiles.on(queryDemFiles.doneData, (_, val) => val);

queryDemFiles.use(({ demandId }) =>
  fetch("https://izba.kras-abs.ru/api/v3/demand/demandFiles", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      demandId: demandId + "",
    }),
    headers: {
      accept: "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent(),
    },
  })
    .then((res) => res.json())
    .then((res) => {
      if (!("files" in res)) {
        let msg = JSON.stringify(res);
        if ("message" in res) msg = res.message;
        return getQueryNewsResObj(msg);
      }
      let groups = res.files as IDemFile[];
      return getQueryNewsResObj("", false, groups);
    })
    .catch((err) => {
      return getQueryNewsResObj(err.message);
    })
);

function getQueryNewsResObj(
  failMsg: string = "",
  fail: boolean = true,
  files: IDemFile[] = [] as IDemFile[]
): IQueryDemFilesResult {
  return {
    loaded: true,
    fail: fail,
    failMsg: failMsg,
    files: files,
  } as IQueryDemFilesResult;
}

export function getAttachImgSrc(mime: string, base64: string | undefined) {
  if (empty(base64) || empty(mime)) return IconDemAttachDoc;
  let type = mime.split("/")[0];
  let base64Prefix = "data:image/png;base64, ";
  switch (type) {
    case "image":
      return base64Prefix + base64;
    case "application/pdf":
      return IconDemAttachPdf;
  }
  return IconDemAttachDoc;
}
